import React from "react";
import "./WaterSensorCard.scss";

const WaterSensorCard = ({ sensor, onClick }) => {
  return (
    <div className="ws-section-card">
      <p className="ws-column-id-label">
        {sensor.name && sensor.name !== "unnamed water sensor"
          ? sensor.name
          : sensor.local_id}
      </p>
      <div className="ws-column-container">
        <div className="ws-metric">
          <span className="ws-metric-label">Water</span>
          <span className={`ws-metric-value ${sensor.water ? "wet" : "dry"}`}>
            {sensor.water ? "Detected" : "Dry"}
          </span>
        </div>

        <div className="ws-metric">
          <span className="ws-metric-label">Sensitivity</span>
          <span className="ws-metric-value neutral">
            {sensor.sensPct ?? "--"}%
          </span>
        </div>
      </div>
      <div className="ws-more-info-row">
        <span className="ws-more-info" onClick={() => onClick(sensor.id)}>
          More Info →
        </span>
      </div>
    </div>
  );
};

export default WaterSensorCard;
